import { useState, useEffect } from 'react';
import { APIGetCommunities } from '../../api/communities/Communities';

export const CommunitySearch = ({ community, setCommunity }) => {
    const [communities, setCommunities] = useState([]);
    const [searchCommunities, setSearchCommunities] = useState('');
    const [communitiesFiltered, setCommunitiesFiltered] = useState([]);

    const handleSearchCommunities = (e) => {
        setSearchCommunities(e.target.value);
        if (e.target.value === '') {
            setCommunitiesFiltered([]);
            return;
        } else if (e.target.value.length < 3) {
            return;
        }
        setCommunitiesFiltered(
            communities.filter((community) =>
                community.name
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            )
        );
    };

    const handelChanges = (inputValue) => {
        setCommunity(inputValue);
    };

    useEffect(() => {
        const fetchCommunities = async () => {
            try {
                const response = await APIGetCommunities();
                setCommunities(response);
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchCommunities();
    }, []);

    return (
        <div className='flex flex-col justify-center  w-full'>
            <h4 >
                <span className={"mb-4 font-semibold text-xl mb-0 lg:mb-1 text-gray-900 "}>Zuständige Gemeinde benennen
                <span className="ml-1 text-sm font-light text-indigo-900 text-xs">(Pflichtfeld)</span>
                </span>
                <p className={"text-sm text-gray-600/60   py-4"}>Bitte benennen Sie die Zuständige Gemeine für Rückfragen zum Plangebiet.</p>
            </h4>
            <label htmlFor='communitySearch' className='mb-4 sr-only'>
                Nach Gemeinde Suchen
            </label>
            {!community ? (
                <>
                    <input
                        id='communitySearch'
                        type='search'
                        className='w-full border font-normal border-gray-500 placeholder-gray-600/60 rounded text-xs  py-4 px-2 mb-5'
                        placeholder='Suche ...'
                        onChange={(e) => handleSearchCommunities(e)}
                    />
                    <div className='flex flex-col  overflow-y-auto'>
                        {communitiesFiltered.length > 0 &&
                            searchCommunities.length > 2 &&
                            communitiesFiltered.map((item, index) => (
                                <div
                                    key={index}
                                    className='flex flex-col border border-gray-300 rounded p-2 mb-2 cursor-pointer'
                                    onClick={() => handelChanges(item)}>
                                    <div>{`${item.name}`}</div>
                                    <div className='text-sm text-gray-550'>
                                        <span className='mr-1'>
                                            Gemeindeschlüssel:
                                        </span>
                                        <span className='tracking-widest'>
                                            {item.id}
                                        </span>
                                    </div>
                                </div>
                            ))}
                    </div>
                </>
            ) : (
                <>
                    <div
                        className='group w-full border border-gray-600 rounded p-2 cursor-pointer'
                        onClick={() => {
                            setCommunity(null);
                            setSearchCommunities('');
                        }}>
                        <div>
                            <div>{`${community.name}`}</div>
                            <div className='text-sm text-gray-550'>
                                <span className='mr-1'>Gemeindeschlüssel:</span>
                                <span className='tracking-widest'>
                                    {community.id}
                                </span>
                            </div>
                        </div>
                    </div>

                    <span
                        className={`${
                            community ? 'flex' : 'hidden'
                        } ml-2 text-xs flex flex-row-reverse mt-2 text-red mb-1 cursor-pointer hover:underline`}
                        onClick={() => {
                            setCommunity(null);
                            setSearchCommunities('');
                        }}>
                    Auswahl löschen
                </span>
                </>
            )}


        </div>
    );
};
